/**
 * src/admin-ui/src/pages/Dashboard.styles.ts
 *
 * Dashboard grid, section and badge styles.
 */

import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const DashboardGrid = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr",
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    gridTemplateColumns: "repeat(2, 1fr)",
  },
  [theme.breakpoints.up("md")]: {
    gridTemplateColumns: "repeat(3, 1fr)",
  },
}));

export const MetricBadge = styled(Box, {
  shouldForwardProp: (prop) => prop !== "status",
})<{ status: "neutral" | "success" | "error" }>(({ theme, status }) => {
  const backgroundColor = {
    neutral: theme.palette.text.disabled,
    success: theme.palette.success.main,
    error: theme.palette.error.main,
  }[status];

  return {
    padding: theme.spacing(0.5, 1.5),
    borderRadius: 999,
    backgroundColor,
    color: theme.palette.getContrastText(backgroundColor),
    fontSize: "0.75rem",
    fontWeight: 700,
  };
});
